import type { ApiConfig } from '../../types'

/**
 * Backpack の入出金履歴 API 設定。
 * `/wapi/v1/capital/deposits` (depositQueryAll) と `/wapi/v1/capital/withdrawals` (withdrawalQueryAll)
 * を 1 type にまとめて取得する。各 endpoint の最大件数は 1000 だが、過剰負荷を避け 500 件ずつ取得する。
 */
export const capitalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'capital-history',
} as const satisfies ApiConfig
